module.exports = __webpack_public_path__ + "img/Sierra Leone.8c2b1a6d.gif";